import { Common } from './Common';

export class UserPd extends Common {
    user_id: string;
    mobile: string;
    country_code: string;
    marital: string;
    department: string;
    profession: string;
    occupation: string;
    education: string;
    current_address2: string;
    blood: string;
    origin_city: string;
    permanent_address: string;
    death_date: Date;

    sub_community: string;
    tag: string;
    country: string;
    state: string;
    district: string;
    location: string;
    email: string;
    status: string;
    pincode: string;
    area: string;
    town: string;
    expertise_offer: string;
    help_required: string;
    achievement: any;

    other_occupation: string;
    other_profession: string;
    other_education: string;
    caste: string;

    business_id: string;
    metaData: any = {};
    privacy: string;
    delete_account_id: string;

}


